/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiNoteFromJSON, StreemApiNoteToJSON, StreemApiRoomFromJSON, StreemApiRoomToJSON, } from './';
export function StreemApiEventsRoomNoteUpdatedFromJSON(json) {
    return StreemApiEventsRoomNoteUpdatedFromJSONTyped(json, false);
}
export function StreemApiEventsRoomNoteUpdatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'room': !exists(json, 'room') ? undefined : StreemApiRoomFromJSON(json['room']),
        'previousRoomNote': !exists(json, 'previous_room_note') ? undefined : StreemApiNoteFromJSON(json['previous_room_note']),
        'updatedRoomNote': !exists(json, 'updated_room_note') ? undefined : StreemApiNoteFromJSON(json['updated_room_note']),
    };
}
export function StreemApiEventsRoomNoteUpdatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room': StreemApiRoomToJSON(value.room),
        'previous_room_note': StreemApiNoteToJSON(value.previousRoomNote),
        'updated_room_note': StreemApiNoteToJSON(value.updatedRoomNote),
    };
}
//# sourceMappingURL=StreemApiEventsRoomNoteUpdated.js.map